<div class="container-fluid maap-root-container">
    <app-header></app-header>
    <div class="container-fluid support-container-grey p-5 mt-5">
        <div class="container text-center ">
            <div class="row">
                <div class="col-12">
                    <h1 class="display-4">
                        Create a ticket to give us a description of your question or possible issue. This allows us to track your request effectively
                    </h1>
                    <h3 class="my-2">Click the icon to begin</h3>   
                    <img class="support-icon" src="assets/images/support_icon.png" alt="">
                </div>
            </div>
           
        </div>
        <div class="container my-5 ">
            <div class="row">
                <div class="col-md-6">
                    <div class="row">
                        <div class="col-4">
                            <img class="support-icon" src="assets/images/support_phone_icon.png" alt="">
                        </div>
                        <div class="col-8">
                            <h3 class="font-weight-bold">CALL US</h3>
                            <p class="support-call-us">
                                (800) 123-4567 <br />
                                Calls are placed in a que to be answered the in order recieved
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="row">
                        <div class="col-4">
                            <img class="support-icon" src="assets/images/support_clock_icon.png" alt="">
                        </div>
                        <div class="col-8">
                            <h3 class="font-weight-bold">HOURS</h3>
                            <p class="support-call-us">
                                (800) 123-4567 <br />
                                U.S. Business 6:00 AM 6:00 PM CST 
                                <br> 
                                On-Call Service*6:00 PM - 6:00 AM
                            </p>
                        </div>
                    </div>
                        
                </div>
            </div>
            
        </div>
          
    </div>
</div>
